<h2>Salon Type Mapping</h2>

<div class="py-3 block h-full" *ngIf="isLoadSalonTypeMasterGridDataSource">
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #salonTypeMasterDataGrid
            id="salonTypeMasterDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [dataSource]="salonTypeMasterDataSource"
            [(selectedRowKeys)]="salonTypeMasterSelectedRowMap"
            (onSelectionChanged)="selectionMasterDataChangedHandler()"
            (onContextMenuPreparing)="salonTypeMasterDataGridContextMenu($event)"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel [enabled]="false"></dxo-load-panel>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            ></dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>

            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-paging [pageSize]="10"></dxo-paging>

            <dxi-column dataField="SalonTypeMappingId" [allowHeaderFiltering]="false" [width]="140" caption="Salon Type Mapping Id"></dxi-column>
            <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
            <dxi-column dataField="SourceSalonType">
                <dxo-header-filter [dataSource]="sourceSalonTypeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="DataProviderCode" caption="Data Provider Code">
                <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapping Counts">
                <dxi-column dataField="TotalCount">
                </dxi-column>
                <dxi-column dataField="NewCount" caption="New">
                    <dxo-header-filter [dataSource]="newHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MapCount" caption="Map">
                    <dxo-header-filter [dataSource]="mapHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SaveCount" caption="Save">
                    <dxo-header-filter [dataSource]="saveHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="OmitCount" caption="Omit">
                    <dxo-header-filter [dataSource]="omitHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="IsInconsistentMappingMessage" caption="Inconsistency">
                    <dxo-header-filter [dataSource]="inconsistencyHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column dataField="Active" caption="Is Active" [visible]="false"></dxi-column>

            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.SalonTypeMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.SalonTypeMappingId)"></dx-button>
                <dx-button class="mr-1" icon="fas fa-map-marker-alt fa-1x" hint="Map" [disabled]="action?.data?.MappingModeId == 1" (onClick)="map(action?.data?.SalonTypeMappingId)"></dx-button>
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1 && currentUser?.UserRoleId > 1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.SalonTypeMappingId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.SalonTypeMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.SalonTypeMappingId)"></dx-button>
            </div>
        </dx-data-grid>
    </div>
</div>
